import {DOCUMENT_TYPE_CAB_FLOOR_MAT_PRODUCT} from '../cab-floor-mat/schema/names';
import {DOCUMENT_TYPE_CAB_SHOE_TRAY_PRODDUCT} from '../cab-shoe-tray/schema/names';
import {DOCUMENT_TYPE_CAB_TABLE_PRODDUCT} from '../cab-table/schema/names';
import {
	DOCUMENT_TYPE_CLOTHING_PRODUCT,
	DOCUMENT_TYPE_CUSTOM_CLOTHING_PRODUCT,
} from '../clothing/schema/names';
import {DOCUMENT_TYPE_PRODUCT} from '../product/schema/names';
import {DOCUMENT_TYPE_STICKER_PRODUCT} from '../stickers/schema/names';

// Kept free of query fragment imports, so it can be used by fragments the product queries depend on
// (such as links) without creating a circular import.

/**
 * Matches any product document type. Works both in `*[...]` filters and in conditional projections
 * (`condition => {...}`). It is spelled out as `_type == ...` comparisons, since Sanity typegen can't
 * narrow `_type in [...]` in conditional projections, nor evaluate expressions like `.map()`.
 */
export const anyProductTypeQueryFilter = `(
	_type == "${DOCUMENT_TYPE_PRODUCT}" ||
	_type == "${DOCUMENT_TYPE_CAB_FLOOR_MAT_PRODUCT}" ||
	_type == "${DOCUMENT_TYPE_CAB_SHOE_TRAY_PRODDUCT}" ||
	_type == "${DOCUMENT_TYPE_CAB_TABLE_PRODDUCT}" ||
	_type == "${DOCUMENT_TYPE_CLOTHING_PRODUCT}" ||
	_type == "${DOCUMENT_TYPE_CUSTOM_CLOTHING_PRODUCT}" ||
	_type == "${DOCUMENT_TYPE_STICKER_PRODUCT}"
)`;
